import { Utils } from 'kryfe-lib';
import { FetchRequest } from './fetchHelper';

const createAPI = Utils.createAPI(FetchRequest);

function createUrl(url) {
  const baseUrl = __HOST_API__;

  if (url) {
    return `${baseUrl}/api/${url}`;
  }

  return baseUrl;
}

export default {
  get(url, params = {}, options = {}) {
    return createAPI.get(
      createUrl(url),
      Object.assign({}, params, { timestamp: Date.now() }),
      Object.assign({}, options, { ajaxCache: false })
    );
  },
  post(url, params = {}, options = {}) {
    const headers = {
      'Content-Type': 'application/json',
    };
    return createAPI.post(
      createUrl(url),
      Object.assign({}, params, { timestamp: Date.now() }),
      Object.assign({ headers }, options)
    );
  },
};



// WEBPACK FOOTER //
// ./src/shared/utils/createAPI.js